export default __webpack_public_path__ + "static/airbnb-1-de1c045dfb56a07d8af96bdf7f6abf65.png";